import React, { SetStateAction, useEffect, useState } from 'react';
import {
    Box,
    Button,
    Flex,
    Input,
    Text,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    useDisclosure,
    Spinner,
    Tooltip
} from '@chakra-ui/react';
import { useAntecipation } from '@/hooks/useAntecipation';
import { showToast } from '@/utils/toast';
import { useRedeem } from '@/hooks/useRedeem';





interface SellerRateSimulator {
    netAmount?: number;
    grossAmount?: number;
    anticipationDate?: string;
    effectiveRate?: any;
}

interface antecipation {
    data: any;
    setUpdatedRedeens :React.Dispatch<SetStateAction<number>>
    updatedRedeens?: number
}

let timeoutId: NodeJS.Timeout;
export default function ModalAntecipacao({data,updatedRedeens,setUpdatedRedeens}:antecipation) {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { simulateAnticipation, confirmAnticipation,loading } = useAntecipation()
    const { getInitialData } = useRedeem();

    const [inputValue, setInputValue] = useState('');
    const [inputValueNumber, setInputValueNumber] = useState<Number>(0);
    const [isLoading, setIsLoading] = useState(false);
    const [valueSimulation, setValueSimulation] = React.useState<SellerRateSimulator>({
        netAmount: 0,
        grossAmount: 0,
        anticipationDate: '',
        effectiveRate: ''
    });
    const formatDate = (dateStr?: string) => {
        if (!dateStr) {
            const now = new Date();
            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const year = now.getFullYear();
            return `${day}/${month}/${year}`;
        }
        const [year, month, day] = dateStr.split('-').map(Number);
        const localDate = new Date(year, month - 1, day);
        const dd = String(localDate.getDate()).padStart(2, '0');
        const mm = String(localDate.getMonth() + 1).padStart(2, '0');
        const yyyy = localDate.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    };

    // function getSimulation(e: React.ChangeEvent<HTMLInputElement>) {
    //     const value = e.target.value;
    //     setInputValue(value);
    //     setIsLoading(true);



    //     clearTimeout(timeoutId);
    //     timeoutId = setTimeout(() => {
    //         const amount = Number(value);
    //         if (amount > 0) {
    //             simulateAnticipation(amount)
    //                 .then((response) => {
    //                     console.log(response);

    //                     setValueSimulation(response);
    //                 })
    //                 .catch((error) => {
    //                     console.error('Erro na simulação:', error);
    //                 })
    //                 .finally(() => {
    //                     setIsLoading(false);
    //                 });
    //         }
    //     }, 800);
    // };




    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let raw = e.target.value.replace(/\D/g, '');
        setInputValueNumber(Number(raw)/100);
        if (!raw) {
            setInputValue('');
            setValueSimulation(null);
            return;
        }
           
        const value = Number(raw) / 100
        setInputValue(value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
        setValueSimulation(null);
    };

    const handleSimulationOrConfirm = async () => {
        if (!valueSimulation) {
            setIsLoading(true);
            let raw = inputValue.replace(/\D/g, '');

            function formatValue(value){
                const valueFormated = value?.replace("R$","")?.replaceAll(".","")?.replaceAll(",","")/100
                return valueFormated;
            }
            const value = Number(raw) / 100

            if (value >= 0 && value <= formatValue(data?.onDemandNetAmount)) {
                try {
                    const response = await simulateAnticipation(value);
                    setValueSimulation(response);
                } catch (err) {
                    console.error("Erro na simulação:", err);
                } finally {
                    setIsLoading(false);
                }
            } else {
                try {
                    const response = await simulateAnticipation(formatValue(data?.onDemandNetAmount));
                    setValueSimulation(response);
                    setInputValue(data?.onDemandNetAmount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
                } catch (err) {
                    console.error("Erro na simulação:", err);
                } finally {
                    setIsLoading(false);
                }
            }
        } else {
            const data = {
                amount: Number(inputValueNumber)
            }
            try {
                const response = await confirmAnticipation(data)
                if(response){
                    showToast({
                        type: 'success',
                        message: "Saldo antecipado com sucesso",
                    });
                }
            } catch (error) {
                return error
            } finally {
                onClose()
                setUpdatedRedeens(updatedRedeens + 1)
            }
        }
    }

    useEffect(() => {
        if (isOpen === false) {
            setInputValue('');
            setValueSimulation(null)
        }
    }, [isOpen])

    return (
        <>
            <Button
                variant="ghost2"
                fontWeight="400"
                fontSize="14px"
                color="black"
                onClick={onOpen}
                disabled={data?.isOnDemandEnabled === false || data?.onDemandNetAmount === 0} 
                size="sm"
                _hover={{
                    bg: "black",
                    color: "white",
                }}
            >
                
                {data?.isOnDemandEnabled === false ? 

                    <Tooltip
                    placement="top"
                    hasArrow
                    borderRadius="5px"
                    label="Solicite ao suporte a atualização de cadastro"
                    >

                    Antecipação
                    </Tooltip> :
                    <Text>
                        Antecipação
                    </Text>
                }
            </Button>

            <Modal
                isOpen={isOpen}
                onClose={onClose} size="xl"
            >
                <ModalOverlay />
                <ModalContent
                    background="white"
                    maxW="936px">
                    <ModalHeader color="Black" >Antecipação de recebíveis</ModalHeader>
                    {/* <ModalCloseButton /> */}
                    <ModalBody>
                        <Flex gap="56px">
                            <Flex flexDirection="column" gap="23px" width="400px">
                                <Box>
                                    <Text color="black" fontSize="12px" fontWeight="400" lineHeight="16px" mb="1">
                                        Valor a antecipar
                                    </Text>
                                    <Input
                                        value={inputValue}
                                        onChange={handleChange}
                                        borderColor="#BEBEBE"
                                        height="40px"
                                        borderRadius="4px"
                                    />


                                </Box>

                                <Box>
                                    <Text color="black" fontSize="12px" fontWeight="400" lineHeight="16px" mb="1">
                                        Saldo disponivel para antecipação:  {data?.onDemandNetAmount}
                                    </Text>
                              
                                </Box>
                                {/* não entra nessa demanda agora */}
                                {/* <Box>
                                    <Text fontSize="12px" mb="1">
                                        Data de antecipação
                                    </Text>
                                    <Input
                                        defaultValue="19/03/2025"
                                        borderColor="#BEBEBE"
                                        height="40px"
                                        borderRadius="4px"
                                    />
                                </Box>

                                <Box>
                                    <Text fontSize="12px" mb="1">
                                        Ordem de antecipação
                                    </Text>
                                    <Flex border="1px solid #BEBEBE" borderRadius="4px" overflow="hidden">
                                        <Button
                                            flex="1"
                                            variant="ghost"
                                            borderRadius="0"
                                            borderRight="1px solid #BEBEBE"
                                        >
                                            Próximo recebível
                                        </Button>
                                        <Button
                                            flex="1"
                                            bg="white"
                                            color="#DF295D"
                                            borderRadius="0"
                                            boxShadow="inset 0 1px 0 #DF295D, inset -1px 0 0 #DF295D, inset 0 -1px 0 #DF295D"
                                        >
                                            Último recebível
                                        </Button>
                                    </Flex>
                                </Box> */}
                            </Flex>
                            {isLoading ?
                                <Flex
                                    border="1px solid #F2E9EC"
                                    bg="#FCFAFB"
                                    borderRadius="4px"
                                    p="24px"
                                    display="flex"
                                    flexDirection="column"
                                    gap="24px"
                                    width="400px"
                                    color="Black"
                                    w="400px"
                                    h="232px"
                                    justifyContent={"center"}
                                    alignItems={"center"}
                                >
                                    <Text>Carregando...</Text>
                                </Flex>
                                : valueSimulation ?

                                    <Box
                                        border="1px solid #F2E9EC"
                                        bg="#FCFAFB"
                                        borderRadius="8px"
                                        p="24px"
                                        display="flex"
                                        flexDirection="column"
                                        gap="24px"
                                        w="400px"
                                        h="232px"
                                        color="Black"
                                        ml="auto"
                                    >
                                        <Text fontSize="16px" letterSpacing="-1%" lineHeight="100%" fontWeight="600">
                                            Simulação de antecipação
                                        </Text>

                                        <Flex flexDirection={"column"} gap="4px">
                                            <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="400">Valor líquido</Text>
                                            <Text fontSize="24px" letterSpacing="-1%" lineHeight="100%" fontWeight="500"> {valueSimulation?.netAmount?.toLocaleString("pt-BR", {
                                                style: "currency",
                                                currency: "BRL",
                                            })}</Text>
                                        </Flex>

                                        <Box fontSize="14px" display="flex" flexDirection="column" gap="8px">
                                            <Flex gap="4px">
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Valor bruto:</Text>
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  > {valueSimulation?.grossAmount?.toLocaleString("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL",
                                                })}</Text>
                                            </Flex>
                                            <Flex gap="4px" fontSize="14px" letterSpacing="0.2px">
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Período de antecipação:</Text>
                                                {valueSimulation?.anticipationDate
                                                    && <Flex gap="2px">
                                                        < Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >
                                                            {formatDate()}
                                                        </Text>
                                                        <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >a</Text>
                                                        < Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >
                                                            {formatDate(valueSimulation?.anticipationDate)}
                                                        </Text>
                                                    </Flex>
                                                }
                                            </Flex>
                                            <Flex gap="4px">
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Taxa efetiva:</Text>
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >{valueSimulation?.effectiveRate}% </Text>
                                            </Flex>
                                        </Box>
                                    </Box> :
                                    <Box
                                        border="1px solid #F2E9EC"
                                        bg="#FCFAFB"
                                        borderRadius="8px"
                                        p="24px"
                                        display="flex"
                                        flexDirection="column"
                                        gap="24px"
                                        w="400px"
                                        h="232px"
                                        color="Black"
                                        ml="auto"
                                    >
                                        <Text fontSize="16px" letterSpacing="-1%" lineHeight="100%" fontWeight="600">
                                            Simulação de antecipação
                                        </Text>

                                        <Flex flexDirection={"column"} gap="4px">
                                            <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="400">Valor líquido</Text>
                                            <Text fontSize="24px" letterSpacing="-1%" lineHeight="100%" fontWeight="500"> R$ 00,00</Text>
                                        </Flex>

                                        <Box fontSize="14px" display="flex" flexDirection="column" gap="8px">
                                            <Flex gap="4px">
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Valor bruto:</Text>
                                                <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  > R$ 00,00</Text>
                                            </Flex>
                                            {/* <Flex gap="4px" fontSize="14px" letterSpacing="0.2px">
                                         <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Período de antecipação:</Text>
                                         {valueSimulation?.anticipationDate
                                             && <Flex gap="2px">
                                                 < Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >
                                                     {formatDate()}
                                                 </Text>
                                                 <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >a</Text>
                                                 < Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >
                                                     {formatDate(valueSimulation?.anticipationDate)}
                                                 </Text>
                                             </Flex>
                                         }
                                     </Flex>
                                     <Flex gap="4px">
                                         <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%" fontWeight="500">Taxa efetiva:</Text>
                                         <Text fontSize="14px" letterSpacing="-1%" lineHeight="100%"  >{valueSimulation?.effectiveRate}% </Text>
                                     </Flex> */}
                                        </Box>
                                    </Box>
                            }


                        </Flex>
                    </ModalBody>

                    <ModalFooter>
                        <Flex justify="flex-end" gap="16px" w="full">
                            <Button 
                                variant="ghost2"
                                onClick={onClose}
                                size="sm"
                                _hover={{
                                    bg: "black",
                                    color: "white",
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                onClick={handleSimulationOrConfirm}
                                isDisabled={!inputValue || loading === true}
                                variant="primaryPink"
                                _hover={{ filter: "brightness(.9)" }}
                                size="sm"
                            >
                                {loading ? (
                                    <Flex align="center" justify="center" gap="2">
                                        <Spinner size="sm" color="white" />
                                        <Text>Carregando...</Text>
                                    </Flex>
                                ) : valueSimulation ? (
                                    'Confirmar antecipação'
                                ) : (
                                    'Simular antecipação'
                                )}
                            </Button>
                        </Flex>
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}
